export const ModalDiasFestivos = ({children, isOpen, closeModal}) => {

  const handleModalContainerClick = e => e.stopPropagation()
  
  return (
    <article className={`modal-dias-festivos ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container-dias-festivos" onClick={handleModalContainerClick}>
      <button className="modal-close-dias-festivos cancelButton" onClick={closeModal}>X</button>
        {children}
      </div>
    </article>
  )
}